<template>
  <th :class="[className, isFirst]">
    <a v-if="sortable"
       @click.prevent="handleSortClick()"
    >
      <span class="name">{{label}}</span>
    </a>
    <span v-else class="name">{{label}}</span>

    <span class="sorting" v-if="sortable">
      <a
          class="asc"
          title="Vzestupně"
          @click.prevent="handleSortClick('ASC')"
          :class="ascIconClass"
          v-translate
      >Vzestupně</a>
      <a
          class="desc"
          title="Sestupně"
          @click.prevent="handleSortClick('DESC')"
          :class="descIconClass"
          v-translate
      >Sestupně</a>
    </span>
  </th>
</template>

<script>
export default {
  props: {
    label: {
      default: '',
      type: String
    },
    attribute: {
      default: '',
      type: String
    },
    sortName: {
      default: '',
      type: String
    },
    sortable: {
      default: false,
      type: Boolean
    },
    className: {
      default: '',
      type: String
    },
    first: {
      default: false,
      type: Boolean
    },
    imageCell: {
      default: false,
      type: Boolean
    },
    imageIcon: {
      default: false,
      type: Boolean
    },
    useTvStationOrder: {
      default: false,
      type: Boolean
    },
    tvStationOrder: ''
  },
  data() {
    return {
      order: 'DESC'
    }
  },
  computed: {
    sortOrder() {
      if (this.useTvStationOrder && this.tvStationOrder !== undefined) {
        if (this.tvStationOrder.includes('-')) {
          return 'DESC'
        } else {
          return 'ASC'
        }
      } else {
        return this.$parent.sortOrder
      }
    },
    active() {
      const { $parent, sortName, attribute } = this
      const sortParam = sortName || attribute
      if (this.useTvStationOrder && this.tvStationOrder !== undefined) {
        return this.tvStationOrder.replace('-', '') === sortParam
      } else {
        return $parent ? $parent.sortBy === sortParam : false
      }
    },
    ascIconClass() {
      return {
        active: this.active && this.sortOrder === 'ASC'
      }
    },
    descIconClass() {
      return {
        active: this.active && this.sortOrder === 'DESC'
      }
    },
    isFirst() {
      return {
        'no_padding_left': this.first
      }
    }
  },

  methods: {
    handleSortClick(sortOrder = null) {
      if (sortOrder === null) {
        if (this.active) {
          if (this.order === 'DESC') {
            this.order = 'ASC'
            sortOrder = 'ASC'
          } else {
            this.order = 'DESC'
            sortOrder = 'DESC'
          }
        } else {
          this.order = 'ASC'
          sortOrder = 'ASC'
        }
      }
      if (this.sortable) {
        const sortParam = this.sortName || this.attribute
        this.$parent.$emit('sort', { order: sortOrder === 'DESC' ? '-' + sortParam : sortParam })
      }
    }
  }
}
</script>
